import {AccountingMatrixDatagridGrid} from '../../components/AccountingMatrixDatagridGrid';
import {getAccountingMatrixDatagridM205ItemsConfig} from './getAccountingMatrixDatagridM205ItemsConfig';

export function AccountingMatrixDatagridM205Items() {
  return <AccountingMatrixDatagridGrid config={getAccountingMatrixDatagridM205ItemsConfig()} />;
}
